// 'use server';
import { FormComponent } from '@/components/FormComponent';
import MediaCarousel from '@/components/media-carousel/MediaCarousel';
// import { Button } from '@/components/ui/button';
import { components } from '@/types/strapi';
import PopupDynamicZoneManager from './manager';

export interface SingleColumnPopupProps {
	content: components['schemas']['SharedPopupContentComponent'];
	className?: string;
	// children?: ReactNode;
	locale?: string;
}

export const SingleColumnPopup = ({
	content,
	className = '',
	locale = 'en',
	// children,
}: SingleColumnPopupProps) => {
	if (!content) {
		return null;
	}
	return (
		<div
			className={`mb-4 flex max-h-[85vh] w-full flex-col rounded-lg shadow-sm ${className}`}
			style={{ backgroundColor: content?.backgroundColor || 'white' }}>
			<div className="flex w-full flex-col gap-4">
				{content.heading && (
					<h2 className="mb-3 text-2xl font-bold text-gray-800">
						{content.heading}
					</h2>
				)}
				{content.description && (
					<div
						className="mb-5 text-gray-600"
						dangerouslySetInnerHTML={{
							__html: content.description,
						}}
					/>
				)}
				{content.images && content.images.length > 0 && (
					<div className="w-full">
						<MediaCarousel images={content.images} />
					</div>
				)}
				{content.form && content.submit_button && (
					<FormComponent
						inputs={content.form.inputs}
						submit_button={content.submit_button}
						pdf_name={content.pdf?.name || ''}
						pdf_url={content.pdf?.url || ''}
					/>
				)}
				{content.dynamic_zone &&
					Array.isArray(content.dynamic_zone) &&
					content.dynamic_zone.length > 0 && (
						<PopupDynamicZoneManager
							dynamicZone={content.dynamic_zone}
							locale={locale}
						/>
					)}
			</div>
		</div>
	);
};
